import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useEffect,
} from "react";
import { getAppConfig } from "./api";
import { STATUS } from "./utils/enums";
import Loading from "./components/Loading";

const ConfigContext = createContext({
  configLang: [],
});

export const ConfigProvider = ({ children }) => {
  const [status, setStatus] = useState(STATUS.IDLE);
  const [error, setError] = useState(null);
  const [configLang, setConfigLang] = useState([]);

  const cacheRef = useRef(null);

  useEffect(() => {
    if (cacheRef.current) {
      setConfigLang(cacheRef.current);
      setStatus(STATUS.SUCCESS);
      return;
    }

    setStatus(STATUS.LOADING);

    const controller = new AbortController();

    const fetchConfig = async () => {
      try {
        const config = await getAppConfig(controller);

        // grab only the localization resources
        const localizationResources = config?.localization?.values ?? [];
        setConfigLang(localizationResources);
        cacheRef.current = localizationResources;
        setStatus(STATUS.SUCCESS);
      } catch (error) {
        setError(error);
        setStatus(STATUS.ERROR);
      }
    };

    fetchConfig();

    return () => controller.abort();
  }, []);

  if (status === STATUS.LOADING) {
    return <Loading />;
  }

  return (
    <ConfigContext.Provider value={{ configLang, status, error }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  return useContext(ConfigContext);
};
